export default {
  data(){
    return {
      URL_MAP: [
        { 
          label: 'Grandes cargas',
          icon: 'mdi-store-settings',
          color: '#E53935',
          kind: 'wholesale',
          link: '',
          development_link: 'http://localhost:3000/',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
        { 
          label: 'Galpão',
          icon: 'mdi-cart',
          color: '#E53935',
          kind: 'retail',
          link: '',
          development_link: 'http://localhost:8080/',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
        { 
          label: 'Gestão',
          icon: 'mdi-note-text-outline',
          color: '#E53935',
          kind: 'backoffice',
          link: '',
          development_link: 'http://localhost:8090/',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
        { 
          label: 'Voltar',
          icon: 'mdi-arrow-left',
          color: 'black',
          kind: '',
          link: '',
          function: () => { this.dialog = false }
        },
      ]
    }
  },
  methods: {
    goToWholesalePage(id){
      this.URL_MAP[0].function( this.URL_MAP[0].link + `order/${id}` )
    },
    
    goToRetailPage(id){
      this.URL_MAP[1].function( this.URL_MAP[1].link + `order/${id}` )
    },
    goToWholesaleDoneOrder(id){
      this.URL_MAP[0].function( this.URL_MAP[0].link + `concluded/order/${id}` )
    },
  
    setLinks(){
      let wholesale = {
        production_link: 'https://grandes_cargas.webcimentao.com.br/',
        development_link: 'http://localhost:3000/',
        qa_link: 'https://grandes_cargas_qa2.webcimentao.com.br/',
      }
      let retail = {
        production_link: 'https://galpoes.webcimentao.com.br/',
        development_link: 'http://localhost:8080/',
        qa_link: 'https://galpoes-qa.webcimentao.com.br/',
      }
      let backoffice = {
        production_link: 'https://gestao.webcimentao.com.br/',
        development_link: 'http://localhost:8090/',
        qa_link: 'https://gestao-qa.webcimentao.com.br/',
      }

      if(process.env.NODE_ENV == 'qa'){
        this.URL_MAP[0].link = wholesale.qa_link
        this.URL_MAP[1].link = retail.qa_link
        this.URL_MAP[2].link = backoffice.qa_link
      }else if(process.env.NODE_ENV == 'production'){
        this.URL_MAP[0].link = wholesale.production_link
        this.URL_MAP[1].link = retail.production_link
        this.URL_MAP[2].link = backoffice.production_link
      }else if(process.env.NODE_ENV == 'development' ){
        this.URL_MAP[0].link = wholesale.development_link
        this.URL_MAP[1].link = retail.development_link
        this.URL_MAP[2].link = backoffice.development_link
      }

    },
  },
  mounted(){
    this.setLinks();
  },
}